const requestAnimationFramePolyfill = callback => {
	if (window.requestAnimationFrame) {
		window.requestAnimationFrame(callback);
	} else {
		window.setTimeout(callback, 1000 / 60);
	}
};

const cancelAnimationFramePolyfill = requestId => {
	cancelAnimationFrame(requestId);
	clearTimeout(requestId);
};

const swing = percent => 0.5 - Math.cos(percent * Math.PI) / 2;

export const scrollY = () => window.scrollY || window.pageYOffset;

export const scrollX = () => window.scrollX || window.pageXOffset;

export const offsetTop = element => element.getBoundingClientRect().top + scrollY();

export const offsetBottom = element => element.getBoundingClientRect().bottom + scrollY();

export const elementWidth = element => element.getBoundingClientRect().width;

export const elementHeight = element => element.getBoundingClientRect().height;

export const animateScrollTop = options => {
	let requestId;

	const timeStep = 1000 / 60;
	const duration = options.duration;
	const start = scrollY();
	const difference = options.to - start;
	let elapsedTime = 0;

	const animateInner = () => {
		elapsedTime += timeStep;
		window.scrollTo(0, start + difference * swing(elapsedTime / duration));
		if (elapsedTime >= duration) {
			options.done();
		} else {
			requestId = requestAnimationFramePolyfill(animateInner);
		}
	};

	requestId = requestAnimationFramePolyfill(animateInner);

	return {
		cancel: () => cancelAnimationFramePolyfill(requestId)
	};
};

export default {scrollY, offsetTop, animateScrollTop};
